module.exports = __webpack_public_path__ + "assets/ad6ac6e27082ce04149d12f7dee9185e.png";